<script setup>
import { ref, computed } from 'vue'
import BasicModal from './utils/BasicModal.vue'

const props = defineProps({
  projectName: String,
})

const emit = defineEmits(['onConfirm'])

const modal = ref(null)
const confirmText = ref("")

const isDeleteBtnEnabled = computed(() => confirmText.value === props.projectName)

function showModal() {
  confirmText.value = ""
  modal.value.showModal()
}

function tryDelete() {
  modal.value.closeModal()
  emit('onConfirm')
}

defineExpose({ showModal })
</script>

<template>
  <BasicModal ref="modal" title="Delete Project" :showDone="false">
    <p class="mb-m">Deleting a project cannot be undone. We recommend you export the project to your files before continuing.</p>
    <p class="mute-header">Confirm</p>
    <p>To confirm, please type the project name ("{{ projectName }}") below:</p>
    <input class="MarginBotM" v-model="confirmText" />
    <button @click="tryDelete" :disabled="!isDeleteBtnEnabled">Delete</button>
  </BasicModal>
</template>
